exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-step[data-v-36fdec00]{text-align:center}.vc-step img[data-v-36fdec00]{width:100%}", ""]);

// exports
